module.exports = __webpack_public_path__ + "img/logo.48c1fb0a.svg";